import dynamic from "next/dynamic";
import ParagraphAndCarouselReviewsConfig from "./paragraph-and-carousel-reviews-config";
import ParagraphAndCarouselReviewsAdvancedConfig from "./paragraph-and-carousel-reviews-advanced-config";

const ParagraphAndCarouselReviewsComponent = dynamic(() => import("./paragraph-and-carousel-reviews-component"));

export default {
  ParagraphAndCarouselReviewsComponent,
  ParagraphAndCarouselReviewsConfig,
  ParagraphAndCarouselReviewsAdvancedConfig
};
